import { useEffect, useState } from 'react'

// Only treat centered Dialog overlays as blocking. MuiDrawer also inherits the
// .MuiModal-root class but its side-anchored backdrop does not warrant hiding
// the copilot FAB — config pages (e.g. /config/station-config/stations) keep a
// keep-mounted Drawer that previously matched the broader Modal selector even
// when closed.
const BLOCKING_OVERLAY_SELECTOR =
  '.MuiDialog-root:not(.MuiModal-hidden) > .MuiBackdrop-root:not(.MuiBackdrop-invisible)'

const isOverlayCurrentlyOpen = (): boolean => {
  try {
    const backdrop = document.querySelector(
      BLOCKING_OVERLAY_SELECTOR,
    ) as HTMLElement | null
    if (!backdrop) return false
    if (backdrop.style.display === 'none') return false
    const style = window.getComputedStyle(backdrop)
    if (style.display === 'none' || style.visibility === 'hidden') return false
    return true
  } catch (error) {
    console.error('useAnyOverlayOpen check failed:', error)
    return false
  }
}

const useAnyOverlayOpen = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const check = () => setIsOpen(isOverlayCurrentlyOpen())

    check()

    const observer = new MutationObserver(check)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
      childList: true,
      subtree: true,
    })

    return () => observer.disconnect()
  }, [])

  return isOpen
}

export default useAnyOverlayOpen
